import { PageMeta } from '@components/page-meta';
import PageContainer from '@components/PageContainer';
import { RouteComponentProps } from '@reach/router';
import ConfigurationFormattingForm from 'src/containers/ConfigurationFormattingForm';

const FormatsPage = (_props: RouteComponentProps) => (
  <>
    <PageMeta title="conditionalFormatting.formattingConfigHeader" />
    <PageContainer>
      <ConfigurationFormattingForm />
    </PageContainer>
  </>
);

export default FormatsPage;
